import { Button } from "@/components/common/button";
import { Card, CardContent, CardHeader, CardTitle } from "@rumbledirect/ui";

import { Link } from "react-router-dom";
import { Suspense } from "react";
import { Topbar } from "@/components/layout/topbar";
import { Content } from "@/components/layout/content";
import { ButtonGroup } from "@rumble-it/common-components/components";
import { UserPermissionShow } from "@/pages/admin/users/permissions/components/user-permissions-show";
import { Loading } from "@/components/common/loading";
import { DeleteEntityDialog } from "@/components/common/delete";
import { useParams } from "react-router-dom";

export default function UserPermissionDetails() {
  const params = useParams();

  return (
    <>
      <Topbar
        title="Permission"
        breadcrumb={[{ title: "Permissions", href: "/users/permissions" }]}
      />

      <Content>
        <Card>
          <CardHeader>
            <CardTitle>Permission</CardTitle>

            <ButtonGroup>
              <Link to={`/users/permissions/${params?.id}/edit`}>
                <Button variant="grey">Wijzigen</Button>
              </Link>

              <DeleteEntityDialog
                id={params?.id}
                entityType="users/permissions"
                redirectTo="/users/permissions"
              />
            </ButtonGroup>
          </CardHeader>

          <CardContent>
            <Suspense fallback={<Loading />}>
              <UserPermissionShow id={params?.id} />
            </Suspense>
          </CardContent>
        </Card>
      </Content>
    </>
  );
}
